<template>
    <form-row title="Agent % Split">
        <div class="w-1/2 pl-4 -mt-4">
            <input-percent
                label="Listing Side"
                name="list_side_percent_split"
                :value="settings.list_side_percent_split"
            />
        </div>
        <div class="w-1/2 pl-4 -mt-4">
            <input-percent
                label="Purchase Side"
                name="purchase_side_percent_split"
                :value="settings.purchase_side_percent_split"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        settings: {},
    },
}
</script>
